@if (visible) {
  <ng-container
    [ngTemplateOutlet]="dialogTemplate()"
    [ngTemplateOutletContext]="{$implicit: hostDialog.getData(), modal: hostDialog}"
  ></ng-container>
}
